import { ActivityTargetTraceType, userType } from "../../DTO";
import { Api } from "../api";

export const ActivityTargetTrace = (user: userType, userId: number) => {
    return new Promise<{ trace: ActivityTargetTraceType }>((resolve, reject) => {
        const api = new Api({
            method: "get",
            path: `activity-targets/user/${userId}/trace`,
            ignore404Redirect: true,
            header: {
                Authorization: `Bearer ${user.access_token}`,
            },
        });

        return api
            .call()
            .then((data: any) => {
                resolve({
                    trace: convertToActivityTargetTrace(data?.data ?? {}),
                });
            })
            .catch((err) => reject(err?.data?.message || err?.message || "Not found"));
    });
};

export const convertToActivityTargetTrace = (data: any): ActivityTargetTraceType => ({
    userId: Number(data?.user_id ?? 0),
    planOrderId: Number(data?.plan_order_id ?? 0),
    currentTarget: {
        minutesPerDay: Number(data?.current_target?.minutes_per_day ?? 0),
        secondsPerDay: Number(data?.current_target?.seconds_per_day ?? 0),
        stepsPerDay: Number(data?.current_target?.steps_per_day ?? 0),
        group: data?.current_target?.group ?? "",
        planGoalId:
            data?.current_target?.plan_goal_id == null
                ? null
                : Number(data.current_target.plan_goal_id),
        updatedAt: data?.current_target?.updated_at ?? null,
    },
    baseline: data?.baseline
        ? {
              group: data.baseline.group ?? "",
              avgMinutes: Number(data.baseline.avg_minutes ?? 0),
              avgSteps: Number(data.baseline.avg_steps ?? 0),
              validDays: Number(data.baseline.valid_days ?? 0),
          }
        : null,
    weeks: Array.isArray(data?.weeks)
        ? data.weeks.map((week: any) => ({
              weekId: Number(week?.week_id ?? 0),
              weekIndex: Number(week?.week_index ?? 0),
              validDays: Number(week?.valid_days ?? 0),
              goalDays: Number(week?.goal_days ?? 0),
              totalMinutes: Number(week?.total_minutes ?? 0),
              totalSteps: Number(week?.total_steps ?? 0),
              avgScore: week?.avg_score == null ? null : Number(week.avg_score),
              days: Array.isArray(week?.days)
                  ? week.days.map((day: any) => ({
                        dayId: Number(day?.day_id ?? 0),
                        minutes: Number(day?.minutes ?? 0),
                        steps: Number(day?.steps ?? 0),
                        goalDay: Boolean(day?.goal_day),
                        score: day?.score == null ? null : Number(day.score),
                    }))
                  : [],
          }))
        : [],
    rules: data?.rules ?? {},
});
